import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { AssistanceUtilitiesWithNavigate } from "../../../AssistanceUtilities";
import InputComponent from "../../../components/InputComponent";
import { useAuth } from "../../../context/AuthContext";
import { useAvailableModulesContext } from "../../../context/AvailableModulesContext";
import Toast from "../../../helpers/Toast";
import { Utilities } from "../../../helpers/Utilities";
import { AssistanceDTO } from "../../../models/Assistance/AssistanceDTO";
import { AssistanceUpdateDTO } from "../../../models/Assistance/AssistanceUpdateDTO";
import { GetAssistanceByClientEquipmentDTO } from "../../../models/Assistance/GetAssistanceByClientEquipment";
import { AssistanceAuxiliaryEquipmentDTO } from "../../../models/AssistanceAuxiliaryEquipments/AssistanceAuxiliaryEquipmentDTO";
import { SearchAuxiliaryEquipmentByDescriptionDTO } from "../../../models/AuxiliaryEquipment/SearchAuxiliaryEquipmentByDescriptionDTO";
import { ClientDTO } from "../../../models/Client/ClientDTO";
import { TimeHistoryDTO } from "../../../models/TimeHistory/TimeHistoryDTO";
import { AssistanceService } from "../../../services/AssistanceService";
import { AuxiliaryEquipmentService } from "../../../services/AuxiliaryEquipmentService";
import { EquipmentService } from "../../../services/EquipmentService";
import ButtonComponent from "../../ButtonComponent";
import SearchSelectComponent from "../../SearchSelectComponent";
import SelectComponent from "../../SelectComponent";
import SoftwareNameAndVersionComponent from "../../SoftwareNameAndVersionComponent";
import { RenderCountersInputs } from "../RenderCountersInputs";
import UpdateClientComponent from "../UpdateClientComponent";


type AssistanceDetailsComponentType = {
    assistance: AssistanceDTO;
    isLoadingAssistance: boolean;
    setAssistance: React.Dispatch<React.SetStateAction<AssistanceDTO>>;
    getAssistance: () => Promise<void>;
};

export type SelectItemsProps = {
    label: string;
    value: string;
};

export function AssistanceDetailsA({ assistance, isLoadingAssistance, setAssistance, getAssistance }: AssistanceDetailsComponentType) {
    const intl = useIntl();
    const { preferedView } = useAuth();
    const navigate = useNavigate();

    const assistanceService = new AssistanceService();
    const equipmentService = new EquipmentService();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isComplete, setIsComplete] = useState<boolean>(false);

    // tipo assistencia
    const [selectedAssistanceType, setSelectedAssistanceType] = useState<string>(Utilities.LoadParameterFromURLQuery("assistanceType", "string", ""));
    const [assistanceTypesComponent, setAssistanceTypesComponent] = useState<SelectItemsProps[]>([]);

    //equipamentos auxiliares
    const auxiliaryEquipmentsService = new AuxiliaryEquipmentService();
    const [isActiveAuxiliaryEquipments, setIsActiveAuxiliaryEquipments] = useState<boolean>(false);
    const [auxiliaryEquipments, setAuxiliaryEquipments] = useState<SelectItemsProps[]>([]);
    const [selectedAuxiliaryEquipments, setSelectedAuxiliaryEquipments] = useState<string>("");

    //módulos ativos
    const { availableModules, assistanceTypes, counterOptions } = useAvailableModulesContext();
    const [projectModuleValue, setProjectModuleValue] = useState<boolean>(false);
    const [isActiveMaintenanceModule, setIsActiveMaintenanceModule] = useState<boolean>(false);
    const [isActiveCountersModule, setIsActiveCountersModule] = useState<boolean>(false);
    const [isActiveCarPlate, setIsActiveCarPlate] = useState<boolean>(false);
    const [isActiveErpEquipments, setIsActiveErpEquipments] = useState<boolean>(false);
    const [isActiveChangeClientInEquipmentAndAssistance, setIsActiveChangeClientInEquipmentAndAssistance] = useState<boolean>(false);
    const [isActivePriorityModule, setIsActivePriorityModule] = useState<boolean>(false);
    const [isActiveReincidenceModule, setIsActiveReincidenceModule] = useState<boolean>(false);
    const [isActiveSoftwareModule, setIsActiveSoftwareModule] = useState<boolean>(false);
    const [isActiveWorkshopInternalNumber, setIsActiveWorkshopInternalNumber] = useState<boolean>(false);
    const [isActiveEquipmentSkuFieldInAssistance, setIsActiveEquipmentSkuFieldInAssistance] = useState<boolean>(false);
    const [isActiveErpSupportModule, setIsActiveErpSupportModule] = useState<boolean>(false);
    const [clientSelected, setClientSelected] = useState<SelectItemsProps | null>(null);
    const [selectedAssistancePriority, setSelectedAssistancePriority] = useState<string>("");
    const [assistancePriority, setAssistancePriority] = useState<SelectItemsProps[]>([]);
    const [incompleteAssistanceSelected, setIncompleteAssistanceSelected] = useState<SelectItemsProps | null>(null);
    const assistanceUtilities = AssistanceUtilitiesWithNavigate(navigate);
    const calcSizeByItems = isActiveErpEquipments === false && isActiveChangeClientInEquipmentAndAssistance === true && assistanceUtilities.IsValidAssistanceStatusToChangeClientAndEquipment(assistance.status) &&
        assistance.hasExecutions === false ? 8 : 12;

    useEffect(() => {
        setClientSelected({ label: assistance.client?.name || '', value: assistance.client?.erpId || '' });
    }, [assistance.client]);

    useEffect(() => {
        if ((assistance.client?.erpId !== clientSelected?.value) && clientSelected?.value) {
            setAssistance(prevAssistance => ({
                ...prevAssistance,
                client: {
                    ...prevAssistance.client,
                    name: clientSelected?.label,
                    erpId: clientSelected?.value,
                } as ClientDTO
            }));
        }
    }, [clientSelected]);

    useEffect(() => {

        if (availableModules.includes("IsActiveAuxiliaryEquipments")) {
            setIsActiveAuxiliaryEquipments(true);
        }
        if (availableModules.includes("ProjectSage50cIsActiveProjectModule")) {
            setProjectModuleValue(true);
        }
        if (availableModules.includes("IsActiveMaintenanceModule")) {
            setIsActiveMaintenanceModule(true);
        }
        if (availableModules.includes("IsActiveCountersModule")) {
            setIsActiveCountersModule(true);
        }
        if (availableModules.includes("IsActiveCarPlate")) {
            setIsActiveCarPlate(true);
        }
        if (availableModules.includes("IsActiveErpEquipments")) {
            setIsActiveErpEquipments(true);
        }
        if (availableModules.includes("IsActiveChangeClientInEquipmentAndAssistance")) {
            setIsActiveChangeClientInEquipmentAndAssistance(true);
        }
        if (availableModules.includes("IsActivePriorityModule")) {
            setIsActivePriorityModule(true);
        }
        if (availableModules.includes("IsActiveReincidenceModule")) {
            setIsActiveReincidenceModule(true);
        }
        if (availableModules.includes("IsActiveSoftwareModule")) {
            setIsActiveSoftwareModule(true);
        }
        if (availableModules.includes("IsActiveWorkshopInternalNumber")) {
            setIsActiveWorkshopInternalNumber(true);
        }
        if (availableModules.includes("IsActiveEquipmentSkuFieldInAssistanceWorkShopView")) {
            setIsActiveEquipmentSkuFieldInAssistance(true);
        }
        if (availableModules.includes("IsActiveErpSupportModule")) {
            setIsActiveErpSupportModule(true);
        }
    }, [availableModules]);

    //passar dados para inputs dinamicos
    const [timeHistory, setTimeHistory] = useState<TimeHistoryDTO>(assistance.timeHistory || {});
    useEffect(() => {
        if (assistance.timeHistory) {
            setTimeHistory(assistance.timeHistory);
        }
    }, [assistance.timeHistory]);

    // ao atualizar valor dos inputs, levar valor para processo de editar assistência
    useEffect(() => {
        setAssistance((prev: AssistanceDTO) => ({ ...prev, timeHistory }));
    }, [timeHistory]);

    // obter equips aux
    useEffect(() => {
        if (assistance && assistance.assistanceAuxiliaryEquipments) {
            const localAssistanceAuxiliaryEquipments = assistance.assistanceAuxiliaryEquipments.map(element => ({
                value: element.erpId,
                label: `${element.description} - ${element.serialNumber}`,
            }));
            const assistanceAuxiliaryEquipmentsString = localAssistanceAuxiliaryEquipments.map(item => item.value).join(",");
            setSelectedAuxiliaryEquipments(assistanceAuxiliaryEquipmentsString);
        }
    }, [assistance]);

    useEffect(() => {
        GetAssistancesByClientEquipmentState(assistance.erpDocType ? assistance.erpDocType : '')
    }, [assistance.incompleteAssistanceId]);


    const GetAssistancesByClientEquipmentState = async (valueAssistance: string): Promise<SelectItemsProps[]> => {

        var assistanceToFilter: GetAssistanceByClientEquipmentDTO =
        {
            valueToFilter: valueAssistance,
            clientErpId: assistance.client?.id,
            clientEquipmentErpId: assistance.equipment?.id
        };

        const response = await assistanceService.GetAssistancesByClientEquipmentFinalState(assistanceToFilter);

        if (response.success === false || response.obj === null) {
            Toast.Show("error", response.message);
            return [];
        }


        if (assistance.incompleteAssistanceId != null) {
            const incompleteAssistance = response.obj?.find(element =>
                element.id = Number(assistance.incompleteAssistanceId),
            )
            if (incompleteAssistance != null) {
                setIncompleteAssistanceSelected({ value: incompleteAssistance.id.toString(), label: `${incompleteAssistance.erpDocType} ${incompleteAssistance.erpSerie} ${incompleteAssistance.erpNumDoc}` })
            }

        }

        const list: SelectItemsProps[] = [];
        response.obj?.forEach((element) => {
            var item: SelectItemsProps = {
                value: `${element.id}`,
                label: `${element.erpDocType} ${element.erpSerie} ${element.erpNumDoc}`
            };
            list.push(item);
        });

        return list;
    };

    const getAuxiliaryEquipments = async (value: string) => {

        const list: SelectItemsProps[] = [];
        var data: SearchAuxiliaryEquipmentByDescriptionDTO = {
            description: value,
        };
        var response = await auxiliaryEquipmentsService.GetAuxiliaryEquipmentsByDescription(data);

        if (response.success === false) {
            Toast.Show("error", response.message);
            return;
        }

        response.obj.forEach((element) => {
            var item: SelectItemsProps = {
                value: element.erpId,
                label: `${element.description} - ${element.serialNumber}`,
            };
            list.push(item);
        });

        setAuxiliaryEquipments(list);
    };

    useEffect(() => {
        if (isActiveAuxiliaryEquipments) {
            getAuxiliaryEquipments("");
        }
    }, [isActiveAuxiliaryEquipments]);


    useEffect(() => {
        if (assistance.id != 0) {
            getAssistance();
        }
    }, []);

    useEffect(() => {
        setIsComplete(!assistance.userCanEdit);
    }, [assistance]);


    // editar assistencia
    const EditAssistance = async () => {

        const selectedAuxiliaryEquipmentsArray = selectedAuxiliaryEquipments
            ?.split(',')
            .map((erpId: string) => {
                const selectedEquipment = auxiliaryEquipments?.find(
                    (auxEquip) => auxEquip.value === erpId
                );
                return selectedEquipment
                    ? new AssistanceAuxiliaryEquipmentDTO(erpId, selectedEquipment.label, "")
                    : null;
            })
            .filter((equipment): equipment is AssistanceAuxiliaryEquipmentDTO => equipment !== null); // remover os nulos

        var data: AssistanceUpdateDTO = {
            id: assistance.id,
            date: assistance.date,
            counter1: assistance.timeHistory.counter1 || 0,
            counter2: assistance.timeHistory.counter2 || 0,
            counter3: assistance.timeHistory.counter3 || 0,
            counter4: assistance.timeHistory.counter4 || 0,
            counter5: assistance.timeHistory.counter5 || 0,
            counter6: assistance.timeHistory.counter6 || 0,
            projectErpId: assistance.project?.erpId ?? null,
            clientErpId: assistance.client?.erpId ?? null,
            assistanceType: (selectedAssistanceType === null || selectedAssistanceType === "" || selectedAssistanceType === undefined) ? assistance.assistanceType : selectedAssistanceType,
            incompleteAssistanceId: incompleteAssistanceSelected?.value != undefined ? Number(incompleteAssistanceSelected.value) : assistance.incompleteAssistanceId,
            priority: selectedAssistancePriority ? Number(selectedAssistancePriority) : assistance.priority,
        };

        setIsLoading(true);
        var response = await assistanceService.Edit(data);
        if (response.success === false) {
            Toast.Show("error", response.message);
            setIsLoading(false);
            return;
        }

        // Não limpar / mostrar anteriores ao editar assistência
        /* setAssistance({
            ...assistance,
            assistanceAuxiliaryEquipments: data.assistanceAuxiliaryEquipments,
        }); */

        Toast.Show("success", "Assistência editada com sucesso");
        setIsLoading(false);
    };

    //obter tipo de assistencia
    const getAssistanceTypes = async () => {
        const list: SelectItemsProps[] = [];

        assistanceTypes.forEach((element) => {
            var item: SelectItemsProps = {
                value: element,
                label: element,
            };
            list.push(item);
        });

        setAssistanceTypesComponent(list);
    };
    useEffect(() => {
        getAssistanceTypes();
    }, []);

    //obter prioridades da assistência
    const getPriorities = async () => {
        const list: SelectItemsProps[] = [];
        const priorityList: number[] = [1, 2, 3];

        priorityList.forEach((priority) => {
            const item: SelectItemsProps = {
                value: priority.toString(),
                label: priority.toString(),
            };
            list.push(item);
        });


        setAssistancePriority(list);
    };
    useEffect(() => {
        getPriorities();
    }, []);


    const downloadDataSheet = async (id: number | null) => {
        setIsLoading(true);
        var response = await equipmentService.DownloadDataSheet(id);
        if (response.success === false) {
            Toast.Show("error", response.message);
            setIsLoading(false);
            return;
        }

        Toast.Show("success", response.message);
        setIsLoading(false);
    }


    return (
        <>
            <Row style={{ margin: "1rem 0px 0px 0px", padding: "0px" }}>
                <SelectComponent
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    style={{ width: "100%", height: "43px" }}
                    label={"Tipo de Assistência"}
                    selectedItemValue={(selectedAssistanceType === null || selectedAssistanceType === "" || selectedAssistanceType === undefined) ? assistance.assistanceType : selectedAssistanceType}
                    items={assistanceTypesComponent}
                    onChange={(t: string) => {
                        setSelectedAssistanceType(t);
                    }}
                    blockItem={isComplete}
                />
            </Row>

            <Row style={{ margin: "0rem 0px 0px 0px", padding: "0px" }}>
                {projectModuleValue && (
                    <>
                        {/* Mostrar componentes quando projectModuleValue for verdadeiro */}
                        <InputComponent
                            xl={12}
                            lg={12}
                            md={12}
                            sm={12}
                            xs={12}
                            style={{ width: "100%" }}
                            type={"text"}
                            value={
                                assistance?.project?.description !== undefined
                                    ? assistance?.project?.description
                                    : "Sem Valor! Assistência criada previamente sem campo Obra."
                            }
                            label={"Nome Obra"}
                            readOnly={true}
                            showLoadingSkeleton={isLoadingAssistance}
                        />
                    </>
                )}
            </Row>
            <Row style={{ margin: "0px", padding: "0px" }}>
                <InputComponent
                    xl={calcSizeByItems}
                    lg={calcSizeByItems}
                    md={calcSizeByItems}
                    sm={calcSizeByItems}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"text"}
                    value={assistance.client?.name}
                    label={"Cliente"}
                    readOnly={true}
                    showLoadingSkeleton={isLoadingAssistance}
                />
                {isActiveErpEquipments === false && isActiveChangeClientInEquipmentAndAssistance === true &&
                    assistanceUtilities.IsValidAssistanceStatusToChangeClientAndEquipment(assistance.status) &&
                    assistance.hasExecutions === false &&
                    (<Col style={{ alignSelf: "center", }} xl={4} lg={4} md={4} sm={4} xs={12} >
                        <UpdateClientComponent
                            equipmentBrand={assistance?.equipment?.brand ?? null}
                            equipmentErpId={assistance?.equipment?.erpId ?? null}
                            equipmentModel={assistance?.equipment?.model ?? null}
                            equipmentName={assistance?.equipment?.name ?? null}
                            equipmentCarPlate={assistance?.equipment?.carPlate ?? null}
                            equipmentSerialNumber={assistance?.equipment?.serialNumber ?? null}
                            loading={isLoadingAssistance}
                            clientSelected={clientSelected}
                            setClientSelected={setClientSelected}
                            assistanceId={assistance?.id}
                            isActiveSearchByCarPlate={isActiveCarPlate}
                        />
                    </Col>)
                }
            </Row>

            {isActiveCarPlate && (
                <Row style={{ margin: "0px", padding: "0px" }}>
                    <InputComponent
                        xl={4}
                        lg={4}
                        md={4}
                        sm={4}
                        xs={12}
                        style={{ width: "100%" }}
                        type={"text"}
                        value={assistance?.equipment?.carPlate}
                        label={"Matrícula"}
                        readOnly={true}
                        showLoadingSkeleton={isLoadingAssistance}
                    />

                    {isActiveWorkshopInternalNumber && (
                        <InputComponent
                            xl={2}
                            lg={2}
                            md={2}
                            sm={12}
                            xs={12}
                            type={"text"}
                            label={intl.formatMessage({ id: "ClientEquipmentBidirecional.AssistanceExtraNumber" })}
                            value={assistance?.workshopInternalNumber}
                            style={{ width: "100%" }}
                            readOnly={true}
                            showLoadingSkeleton={isLoadingAssistance}
                        />
                    )}
                </Row>
            )}

            <Row style={{ margin: "0px", padding: "0px" }}>
                <InputComponent
                    xl={4}
                    lg={4}
                    md={4}
                    sm={4}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"text"}
                    value={assistance?.equipment?.serialNumber}
                    label={"Nº Série"}
                    readOnly={true}
                    showLoadingSkeleton={isLoadingAssistance}
                />
                <InputComponent
                    xl={4}
                    lg={4}
                    md={4}
                    sm={4}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"text"}
                    value={assistance?.equipment?.brand}
                    label={"Marca"}
                    readOnly={true}
                    showLoadingSkeleton={isLoadingAssistance}
                />

                <InputComponent
                    xl={4}
                    lg={4}
                    md={4}
                    sm={4}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"text"}
                    value={assistance?.equipment?.model}
                    label={"Modelo"}
                    readOnly={true}
                    showLoadingSkeleton={isLoadingAssistance}
                />

                <Row style={{ margin: "0px", padding: "0px" }}>
                    {isActiveEquipmentSkuFieldInAssistance && (
                        <InputComponent
                            xl={4}
                            lg={4}
                            md={4}
                            sm={12}
                            xs={12}
                            type={"text"}
                            label={intl.formatMessage({ id: "ClientEquipmentBidirecional.EquipmentSKU" })}
                            value={assistance?.equipment?.sku}
                            style={{ width: "100%" }}
                            readOnly={true}
                            showLoadingSkeleton={isLoadingAssistance}
                        />
                    )}
                </Row>
                {isActiveSoftwareModule &&
                    <Row style={{ margin: "0px", padding: "0px", alignItems: "flex-end", alignContent: "flex-end" }}>
                        <InputComponent
                            xl={4}
                            lg={4}
                            md={4}
                            sm={12}
                            xs={12}
                            style={{ width: "100%" }}
                            type={"text"}
                            value={assistance?.softwareName ?? ""}
                            label={intl.formatMessage({ id: "ClientEquipmentBidirecional.SoftwareName" })}
                            readOnly={true}
                            showLoadingSkeleton={isLoadingAssistance}
                        />
                        <InputComponent
                            xl={4}
                            lg={4}
                            md={4}
                            sm={12}
                            xs={12}
                            style={{ width: "100%" }}
                            type={"text"}
                            value={assistance?.softwareVersion ?? ""}
                            label={intl.formatMessage({ id: "ClientEquipmentBidirecional.SoftwareVersion" })}
                            readOnly={true}
                            showLoadingSkeleton={isLoadingAssistance}
                        />

                        <SoftwareNameAndVersionComponent
                            equipmentId={assistance.equipment?.id ?? 0}
                            currentSoftwareName={assistance?.softwareName ?? null}
                            currentSoftwareVersion={assistance?.softwareVersion ?? null}
                            assistance={assistance}
                            loading={isLoadingAssistance}
                            setAssistance={setAssistance}
                            userCanEdit={!assistance.userCanEdit}
                        ></SoftwareNameAndVersionComponent>
                    </Row>
                }

            </Row>
            <Row style={{ margin: "0px", padding: "0px" }}>
                <InputComponent
                    xl={3}
                    lg={3}
                    md={3}
                    sm={3}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"date"}
                    value={assistance?.date}
                    label={"Dia"}
                    readOnly={true}
                    showLoadingSkeleton={isLoadingAssistance}
                />

                <InputComponent
                    xl={2}
                    lg={2}
                    md={2}
                    sm={2}
                    xs={12}
                    style={{ width: "100%" }}
                    type={"time"}
                    value={assistance?.date != null ? Utilities.GetTimeFromDateTime(new Date(assistance?.date)) : ""}
                    label={"Hora"}
                    readOnly={true}
                    showLoadingSkeleton={isLoadingAssistance}
                />
            </Row>

            {/* Estado 2 - Contadores */}
            {isActiveCountersModule && !isActiveErpSupportModule && (
                <>
                    <label style={{ margin: "0px", padding: "13px", fontWeight: "bold" }}>
                        {intl.formatMessage({ id: "Screens.AssistanceEditB.CountersTitle" })}
                    </label>
                    <Row style={{ margin: "0px", padding: "0px" }}>
                        {RenderCountersInputs(counterOptions, timeHistory, setTimeHistory, isComplete)}
                    </Row>
                </>
            )}

            {isActivePriorityModule &&
                <Row style={{ margin: "0px", padding: "0px", alignItems: "flex-end", alignContent: "flex-end" }}>
                    <SelectComponent
                        xl={12}
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        style={{ width: "100%", height: "43px" }}
                        label={"Prioridade"}
                        selectedItemValue={(selectedAssistancePriority === null || selectedAssistancePriority === "" || selectedAssistancePriority === undefined) ? assistance.priority?.toString() ?? "" : selectedAssistancePriority}
                        items={assistancePriority}
                        onChange={(t: string) => {
                            setSelectedAssistancePriority(t);
                        }}
                        blockItem={isComplete}
                        showLoadingSkeleton={isLoadingAssistance}
                    />
                </Row>
            }

            {isActiveReincidenceModule &&
                <>
                    <label style={{ margin: "0px", padding: "13px", fontWeight: "bold" }}>
                        {intl.formatMessage({ id: "Screens.AssistanceEdit.IncompleteAssistanceTitle" })}
                    </label>
                    <Row style={{ margin: "0px", padding: "0px", alignItems: "flex-end", alignContent: "flex-end" }}>
                        <SearchSelectComponent
                            xl={7}
                            lg={7}
                            md={7}
                            sm={12}
                            xs={12}
                            label={intl.formatMessage({ id: "Screens.AssistanceEdit.IncompleteAssistanceAssigned" })}
                            loadOptions={GetAssistancesByClientEquipmentState}
                            onChange={(e: SelectItemsProps) => {
                                setIncompleteAssistanceSelected(e);
                            }}
                            value={incompleteAssistanceSelected}
                            style={{ width: "100%" }}
                        />

                        <Col xl={5} lg={5} md={5} sm={12} xs={12}>
                            <ButtonComponent
                                style={{ width: "100%", marginBottom: "8px" }}
                                text={intl.formatMessage({ id: "Common.Buttons.NavigateToAssistance" })}
                                onClick={() => assistanceUtilities.NavigateToAssistanceDetails(Number(incompleteAssistanceSelected?.value), preferedView, false, true)}

                            />
                        </Col>
                    </Row>

                </>
            }

            {isComplete ? (
                ""
            ) : (
                <Row style={{ margin: "0px", padding: "0px", justifyContent: "flex-end" }}>
                    <Col xl={3} lg={3} md={3} sm={12} xs={12}>
                        <ButtonComponent
                            style={{ width: "100%", marginTop: "10px" }}
                            text={intl.formatMessage({ id: "AssistanceEditA.Save" })}
                            onClick={() => EditAssistance()}
                            disabled={isLoading}
                        />
                    </Col>
                </Row>
            )}
        </>
    );
}